import { StringDevUIFieldDescriptor as UIFieldDescriptor } from "../../core/ui/StringDevUISchema";
import { GridAdapter } from "./GridAdapter";

/**
 * Center lines adapter.
 * Renders vertical and/or horizontal center axes.
 * Simple but essential for alignment verification.
 */
export class CenterAdapter extends GridAdapter {
  readonly type = "center";
  readonly label = "Center";
  readonly icon = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="10" height="10" rx="3" fill="currentColor"/><path d="M8 2V14" stroke="white"/><path d="M2 8H14" stroke="white"/></svg>`;

  getDefaults(): Record<string, any> {
    return {
      showVertical: true,
      showHorizontal: true,
      color: "#50e24a",
      opacity: 0.5,
      dashed: true,
    };
  }

  getUISchema(): UIFieldDescriptor[] {
    return [
      { type: "toggle", key: "showVertical", label: "Vertical", default: true },
      { type: "toggle", key: "showHorizontal", label: "Horizontal", default: true },
      { type: "divider" },
      { type: "color", key: "color", label: "Color", default: "#50e24a" },
      { type: "range", key: "opacity", label: "Opacity", default: 0.5, min: 0, max: 1, step: 0.01 },
      { type: "toggle", key: "dashed", label: "Dashed", default: true },
    ];
  }

  render(
    svg: SVGSVGElement,
    width: number,
    height: number,
    settings: Record<string, any>,
  ): void {
    const group = this.getGroup(svg, settings.__instanceId);
    const { showVertical, showHorizontal, color, opacity, dashed } = settings;
    const dashAttr = dashed ? "6 3" : "none";

    if (showVertical) {
      const line = this.createLine(width / 2, 0, width / 2, height, color, opacity);
      if (dashed) line.setAttribute("stroke-dasharray", dashAttr);
      group.appendChild(line);
    }

    if (showHorizontal) {
      const line = this.createLine(0, height / 2, width, height / 2, color, opacity);
      if (dashed) line.setAttribute("stroke-dasharray", dashAttr);
      group.appendChild(line);
    }
  }
}
